import React, { FC, ReactNode } from "react";
import styles from "./Content.module.scss";

export const Content: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  return <div className={styles.content}>{children}</div>;
};
